(function() {
  'use strict';

  /* ──────────────── CONFIG ──────────────── */
  /* Store values come from the small inline config the snippet prints
     (window.HEVO_CART_CFG); this file itself is static so it can be cached. */
  var CFG = window.HEVO_CART_CFG || {};
  var LOCALE = String(CFG.locale || 'en').toLowerCase().slice(0, 2);
  var CURRENCY_CODE = CFG.currencyCode || '';
  var CURRENCY_SYMBOL = CFG.currencySymbol || '';

  var TRANSLATIONS = {
    en: {
      cart: 'Cart',
      emptyCart: 'Your cart is empty',
      continueShopping: 'Continue shopping',
      emptyCta: 'Find the perfect lens for you',
      remove: 'Remove',
      freeShippingUnlocked: 'You\'ve unlocked <strong>free shipping!</strong>',
      freeShippingAway: 'You\'re <strong>{amount}</strong> away from free shipping.',
      upsellTitle: 'Complete your collection',
      upsellSub: 'Add another pair and save <strong>{amount}</strong> — 30% off both',
      recsTitle: 'Complete Your Sleep',
      discountNote: 'Discount codes can be applied at checkout.',
      discountToggle: 'Add discount code',
      discountPlaceholder: 'Discount code',
      discountApply: 'Apply',
      discountApplied: 'Code applied',
      discountInvalid: 'That code isn\'t valid',
      discountAlready: 'Code already added',
      discountRemove: 'Remove discount',
      total: 'Total',
      checkout: 'Checkout',
      acceleratedOr: 'or check out with',
      trustText: 'Customers rate HEVO 4.5/5',
      addBtn: '+ ADD',
      addedBtn: '✓ Added',
      saved: 'You save {amount}',
      qtyDec: 'Decrease quantity',
      qtyInc: 'Increase quantity',
      limitedSale: 'Limited sale',
      onlyLeft: 'Only {count} left',
pairAddOne: 'Add a second pair for only {amount}',
      pairRecFocus: 'We recommend matching with Focus Lens for daytime blocking or creative work.',
      pairRecSleep: 'We recommend matching with Sleep Lens to maximise melatonin before bed.',
            upsellTitleSleep: 'Add Sleep Lens for winding down at night',
      upsellTitleFocus: 'Add Focus Lens for your daytime screens',
      upsellTitleRelax: 'Add Relax Lens for calm evenings',
      free: 'FREE',
      giftTag: 'GIFT',
      stockOnlyLeft: '{count} left'
    },
    sv: {
      cart: 'Varukorg',
      emptyCart: 'Din varukorg är tom',
      continueShopping: 'Fortsätt handla',
      emptyCta: 'Hitta rätt lins för dig',
      remove: 'Ta bort',
      freeShippingUnlocked: 'Du har låst upp <strong>fri frakt!</strong>',
      freeShippingAway: 'Du är <strong>{amount}</strong> från fri frakt.',
      upsellTitle: 'Skapa en perfekt rutin',
      upsellSub: 'Lägg till ett par och spara <strong>{amount}</strong> – 30% på båda',
      recsTitle: 'Optimera din sömn',
      discountNote: 'Rabattkoder läggs till i kassan.',
      discountToggle: 'Lägg till rabattkod',
      discountPlaceholder: 'Rabattkod',
      discountApply: 'Använd',
      discountApplied: 'Koden har lagts till',
      discountInvalid: 'Koden är inte giltig',
      discountAlready: 'Koden är redan tillagd',
      discountRemove: 'Ta bort rabatt',
      total: 'Totalt',
      checkout: 'Till kassan',
      acceleratedOr: 'eller betala med',
      trustText: 'Kunder ger HEVO 4,5/5',
      addBtn: '+ LÄGG TILL',
      addedBtn: '✓ Tillagd',
      saved: 'Du sparar {amount}',
      qtyDec: 'Minska antal',
      qtyInc: 'Öka antal',
      limitedSale: 'Begränsat pris',
      onlyLeft: 'Endast {count} kvar',
pairAddOne: 'Lägg till ett par till för endast {amount}',
      pairRecFocus: 'Vi rekommenderar att matcha med Focus Lens för blockering under dagen eller kreativt arbete.',
      pairRecSleep: 'Vi rekommenderar att matcha med Sleep Lens för maximering av melatonin före läggdags.',
            upsellTitleSleep: 'Lägg till Sleep Lens för att varva ner på kvällen',
      upsellTitleFocus: 'Lägg till Focus Lens för skärmtimmar på dagen',
      upsellTitleRelax: 'Lägg till Relax Lens för lugna kvällar',
      free: 'GRATIS',
      giftTag: 'GÅVA',
      stockOnlyLeft: '{count} kvar'
    }
  };

  var T = TRANSLATIONS[LOCALE] || TRANSLATIONS['en'];

  /* The inline maps above only carry en and sv, so every other language fell
     back to English. These three come from the locale files instead, which is
     what Shopify's translation tooling reads — add the language in the admin
     and the note follows. Guarded: a missing key makes `t` return the literal
     "Translation missing: ...", which would be worse than the inline copy. */
  (function () {
    var fromLocale = CFG.pairNote || {};
    for (var k in fromLocale) {
      var v = fromLocale[k];
      if (!v || v.indexOf('Translation missing') !== -1) continue;
      /* A key that exists only in en.default.json makes `t` return ENGLISH for
         every other language rather than failing — which silently overwrote the
         Swedish copy in the map above. So take the locale value only when it is
         something other than the English fallback, or when there is no inline
         copy for this language to protect. */
      var inline = TRANSLATIONS[LOCALE] && TRANSLATIONS[LOCALE][k];
      if (inline && v === TRANSLATIONS['en'][k]) continue;
      T[k] = v;
    }
  })();

  var FREE_SHIPPING_THRESHOLDS = {
    'EUR': 70,
    'SEK': 400,
    'USD': 70,
    'GBP': 60,
    'DKK': 500,
    'NOK': 500,
    'AUD': 100,
    'AED': 250,
    'HKD': 550
  };

  var CONFIG = {
    freeShippingThreshold: FREE_SHIPPING_THRESHOLDS[CURRENCY_CODE] || 70,
    /* Order drives the upsell carousel — filter/Promise.all/forEach all
       preserve it. Mask leads. */
    accessories: [
      'sleep-mask',
      'nose-strips-black',
      'mouth-sleep-tape'
    ],
    lensMap: {
      'sleep': 'focus',
      'focus': 'sleep'
    }
  };

  var FREE_SHIPPING_THRESHOLDS = {
    'EUR': 70,
    'SEK': 400,
    'USD': 70,
    'GBP': 60,
    'DKK': 500,
    'NOK': 500,
    'AUD': 100,
    'AED': 250,
    'HKD': 550
  };

  var CONFIG = {
    freeShippingThreshold: FREE_SHIPPING_THRESHOLDS[CURRENCY_CODE] || 70,
    /* Order drives the upsell carousel — filter/Promise.all/forEach all
       preserve it. Mask leads. */
    accessories: [
      'sleep-mask',
      'nose-strips-black',
      'mouth-sleep-tape'
    ],
    lensMap: {
      'sleep': 'focus',
      'focus': 'sleep'
    }
  };

  /* ──────────────── STATE ──────────────── */
  var cartData = null;

  /* Manually-entered discount codes (customer typed them into the drawer
     input). Kept separate from the automatic codes so they survive the
     clear+reapply cycle _syncDiscounts runs on every cart change, and
     persist across drawer re-opens within the session. _computeCodes
     folds these in so they're always re-applied and carried to checkout. */
  var _manualCodes = [];
  try {
    var _mcRaw = sessionStorage.getItem('hevoManualCodes');
    if (_mcRaw) _manualCodes = JSON.parse(_mcRaw) || [];
  } catch (e) { _manualCodes = []; }
  function _persistManualCodes() {
    try { sessionStorage.setItem('hevoManualCodes', JSON.stringify(_manualCodes)); } catch (e) {}
  }

  /* ──────────────── CART API ──────────────── */
  var CartAPI = {
    get: function() {
      return fetch('/cart.js').then(function(res) { return res.json(); });
    },
    add: function(variantId, qty, properties) {
      qty = qty || 1;
      var item = { id: variantId, quantity: qty };
      if (properties) item.properties = properties;
      return CartAPI.addBatch([item]);
    },
    /* Batch add — adds multiple items in a SINGLE /cart/add.js call.
       Used by the gift bundle so mask + nose strips go in one network
       round-trip instead of two sequential ones. */
    addBatch: function(itemsList) {
      window._hevoInternalAdd = true;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsList })
      }).then(function(res) {
        window._hevoInternalAdd = false;
        return res.json();
      }).catch(function(err) {
        window._hevoInternalAdd = false;
        throw err;
      });
    },
    change: function(line, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function(res) { return res.json(); });
    },
    /* applyDiscount removed 2026-05-03 — the in-drawer apply form was
       retired; codes are entered at checkout instead. */
  };

  /* ──────────────── PRODUCT FETCH ──────────────── */
  /* Memoize product fetches — used by upsells, accessories, AND the
   * per-line stock pill. Prevents N+1 fetches when the same product
   * appears multiple times in the cart. */
  var _productCache = {};

  function fetchProduct(handle) {
    if (_productCache[handle]) return Promise.resolve(_productCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function(res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function(p) {
        if (p) _productCache[handle] = p;
        return p;
      })
      .catch(function() { return null; });
  }

  /* ──────────────── STOCK PILL (glasses only, low stock) ──────────────── */
  /* Detect a glasses (lens-bearing) product handle.
   * The substring check matches handles like `the-relax-pair-sleep-lens`,
   * but it would *also* match `mouth-sleep-tape` because of the `-sleep-`
   * substring. So we explicitly exclude every known accessory handle
   * before doing the substring sniff — accessories never count as lenses,
   * regardless of what's in their slug. */
  function _isLensHandle(h) {
    if (!h) return false;
    if (CONFIG.accessories.indexOf(h) !== -1) return false;
    return h.indexOf('-sleep-') !== -1 ||
           h.indexOf('-focus-') !== -1 ||
           h.indexOf('-relax-') !== -1;
  }

  function _stockPillMarkup(qty) {
    /* Only show when we have a real low number (1–9). Anything else
     * (untracked / well-stocked / 0) → no pill. */
    if (typeof qty !== 'number' || qty < 1 || qty >= 10) return '';
    return '<span class="hevo-stock-pill hevo-stock-pill--orange">' +
             '<span class="hevo-stock-pill__dot"></span>' +
             T.stockOnlyLeft.replace('{count}', qty) +
           '</span>';
  }

  /* After each cart render, progressively enhance glasses lines with a
   * stock urgency pill. Non-blocking — fetches in parallel with any
   * other work. Each line is keyed by data-line (1-indexed). */
  function _enhanceStockPills(items) {
    items.forEach(function(item, idx) {
      if (!_isLensHandle(item.handle)) return;
      fetchProduct(item.handle).then(function(p) {
        var line = document.querySelector('.hevo-cart-item[data-line="' + (idx + 1) + '"]');
        if (!p || !p.variants) {
          console.warn('[hevo-stock] /products/' + item.handle + '.js returned no product');
          return;
        }
        var variant = null;
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].id === item.variant_id) { variant = p.variants[i]; break; }
        }
        if (!variant) {
          console.warn('[hevo-stock] variant', item.variant_id, 'not found in', item.handle);
          return;
        }
        var qty = variant.inventory_quantity;
        /* Diagnostic: tag the line so you can inspect via DevTools.
         *   data-stock-qty   = raw number (or 'null' if not tracked)
         *   data-stock-mgmt  = Shopify inventory_management value
         * Also logs once per fetch so you can see what the API is
         * actually returning. */
        if (line) {
          line.setAttribute('data-stock-qty', (qty == null ? 'null' : String(qty)));
          line.setAttribute('data-stock-mgmt', variant.inventory_management || 'untracked');
        }
        console.log('[hevo-stock]', item.handle, 'variant=' + item.variant_id,
                    'qty=', qty, 'mgmt=', variant.inventory_management);

        var markup = _stockPillMarkup(qty);
        if (!markup) return;
        if (!line) return;
        var qtyEl = line.querySelector('.hevo-cart-item__qty');
        if (!qtyEl) return;
        var actions = qtyEl.parentNode;
        var existing = actions.querySelector('.hevo-stock-pill');
        if (existing) existing.remove();
        qtyEl.insertAdjacentHTML('afterend', markup);
      });
    });
  }

  /* For each cart line, look up the product's variant via the cached
     /products/:handle.js fetch (the same one _enhanceStockPills already
     warms) and, if the variant has a compare_at_price greater than its
     current price, swap the rendered price block to show the
     strikethrough "was" price next to the sale price.

     Why this exists: cart.js line items don't reliably surface
     `compare_at_price` (the field is on variants but isn't always
     mirrored onto line items), so the synchronous renderCartItems pass
     can't always detect a variant-level sale on its own. This async
     enhancement fills that gap.

     Skips lines that already have a strikethrough (gift / line
     discount / cart.js-surfaced compare-at), and skips non-lens items
     to avoid unnecessary product fetches for accessories. */
  function _enhanceCompareSales(items) {
    /* Sum compare-at across lines so the footer can show a struck total.
       Resolved per line as each product JSON lands, then painted once. */
    var _cmpTotal = 0, _cmpPending = 0, _cmpAny = false;
    function _paintCompareTotal() {
      var el = document.getElementById('hevoCartCompare');
      if (!el || _cmpPending > 0) return;
      var totalEl = document.getElementById('hevoCartTotal');
      var shown = totalEl ? totalEl.textContent : '';
      if (_cmpAny && _cmpTotal > 0) {
        var formatted = formatMoney(_cmpTotal);
        /* Never show a "was" identical to the price actually charged. */
        if (formatted !== shown) {
          el.textContent = formatted; el.style.display = 'inline';
          var savedEl = document.getElementById('hevoCartSaved');
          if (savedEl && _displayTotal !== null) {
            var sv = _cmpTotal - _displayTotal;
            if (sv > 0) {
              savedEl.textContent = T.saved.replace('{amount}', formatMoney(sv));
              savedEl.style.display = 'block';
            }
          }
          return;
        }
      }
      el.style.display = 'none';
    }

    items.forEach(function(item, idx) {
      /* Baseline: every line contributes what it actually costs; lines with a
         compare-at add the difference on top below. */
      _cmpTotal += item.final_line_price;
      var lineEl = document.querySelector('.hevo-cart-item[data-line="' + (idx + 1) + '"]');
      /* Automatic discounts (nose strips, mask, second pair without a
         compare-at) only show as original > final. Count them too, or
         "Du sparar" comes out short of what the lines actually save. */
      var autoOff = (item.original_line_price || 0) - item.final_line_price;
      if (!_isLensHandle(item.handle)) {
        if (autoOff > 0) { _cmpTotal += autoOff; _cmpAny = true; }
        return;
      }

      _cmpPending++;
      fetchProduct(item.handle).then(function(p) {
        if (!p || !p.variants) return;
        var variant = null;
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].id === item.variant_id) { variant = p.variants[i]; break; }
        }
        if (!variant) return;
        var compareUnit = variant.compare_at_price;
        if (!compareUnit || compareUnit <= item.price) {
          if (autoOff > 0) { _cmpTotal += autoOff; _cmpAny = true; }
          return;
        }

        var compareLine = compareUnit * item.quantity;
        _cmpTotal += (compareLine - item.final_line_price); _cmpAny = true;
        if (!lineEl) return;
        /* Overrides any strikethrough already painted from the cart discount:
           that one shows the pre-discount price (675), while compare-at is the
           actual original (995). Leaving it would make the lines fail to add
           up to the struck total. */
        var priceBlock  = lineEl.querySelector('.hevo-cart-item__price-block');
        if (!priceBlock) return;

        priceBlock.innerHTML =
          '<div class="hevo-cart-item__price hevo-cart-item__price--sale">' + formatMoney(item.final_line_price) + '</div>' +
          '<div class="hevo-cart-item__price hevo-cart-item__price--compare">' + formatMoney(compareLine) + '</div>';
      }).catch(function () {}).then(function () {
        _cmpPending--; _paintCompareTotal();
      });
    });
  }

  /* ──────────────── RENDER ──────────────── */

  function formatMoney(cents) {
    /* Whole amounts drop the decimals (973 kr, not 973.00 kr), matching the
       product page. Swedish writes 1 017 kr and 486,50 kr: non-breaking space
       for thousands, comma for decimals. Other locales keep 1,017 / 486.50. */
    var sv = LOCALE === 'sv';
    var n = (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2).split('.');
    n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, sv ? '\u00a0' : ',');
    var amount = n.join(sv ? ',' : '.');
    var suffixCurrencies = ['SEK', 'NOK', 'DKK', 'CZK', 'PLN'];
    if (suffixCurrencies.indexOf(CURRENCY_CODE) !== -1) {
      return amount + ' ' + CURRENCY_SYMBOL;
    }
    return CURRENCY_SYMBOL + amount;
  }

  function renderShippingBar(totalCents) {
    var totalEur = totalCents / 100;
    var threshold = CONFIG.freeShippingThreshold;
    var remaining = Math.max(0, threshold - totalEur);
    var pct = Math.min(100, (totalEur / threshold) * 100);
    var bar = document.getElementById('hevoShippingBar');
    var text = document.getElementById('hevoShippingText');
    var fill = document.getElementById('hevoShippingFill');

    if (remaining <= 0) {
      bar.classList.add('hevo-shipping-bar--complete');
      text.innerHTML = T.freeShippingUnlocked;
    } else {
      bar.classList.remove('hevo-shipping-bar--complete');
      text.innerHTML = T.freeShippingAway.replace('{amount}', formatMoney(remaining * 100));
    }
    fill.style.width = pct + '%';
  }

  function renderCartItems(items) {
    var container = document.getElementById('hevoCartItems');
    var emptyEl = document.getElementById('hevoCartEmpty');
    var footerEl = document.getElementById('hevoCartFooter');

    if (!items || items.length === 0) {
      container.innerHTML = '';
      emptyEl.style.display = 'flex';
      footerEl.style.display = 'none';
      document.getElementById('hevoUpsellSection').style.display = 'none';
      document.getElementById('hevoRecsSection').style.display = 'none';
      var _ds = document.getElementById('hevoDiscountSection'); if (_ds) _ds.style.display = 'none';
      document.getElementById('hevoShippingBar').style.display = 'none';
      return;
    }

    emptyEl.style.display = 'none';
    footerEl.style.display = 'block';
    var _ds2 = document.getElementById('hevoDiscountSection'); if (_ds2) _ds2.style.display = 'block';
    document.getElementById('hevoShippingBar').style.display = 'block';

    /* ── Second-pair nudge ──────────────────────────────────────────────
       Shown only when the cart holds exactly ONE pair of glasses. The price
       mirrors hevo-second-pair: two pairs cost pair_price * 2 * 70/100, so the
       second pair adds pair_price * 0.4. Kept as the same percentage rather
       than a baked 0.6 so the two stay in step if the bundle ever changes. */
    var BUNDLE_PCT = 70;

    function _lensOf(h) {
      if (!_isLensHandle(h)) return null;
      if (h.indexOf('-sleep-') !== -1) return 'sleep';
      if (h.indexOf('-relax-') !== -1) return 'relax';
      if (h.indexOf('-focus-') !== -1) return 'focus';
      return null;
    }

    /* Index of the lone pair, or -1. Counts quantity, not lines: two of the
       same frame on one line is still two pairs and must not show the nudge. */
    function _soloPairIndex(list) {
      var total = 0, at = -1;
      for (var i = 0; i < list.length; i++) {
        if (!_isLensHandle(list[i].handle)) continue;
        total += list[i].quantity;
        at = i;
      }
      return total === 1 ? at : -1;
    }

    var _soloIdx = _soloPairIndex(items);

    container.innerHTML = items.map(function(item, idx) {
      var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_160x160$1') : '';
      var variantHtml = item.variant_title ? '<div class="hevo-cart-item__variant">' + item.variant_title + '</div>' : '';
      var priceHtml;

      /*
       * Price rendering priority:
       *   1. Gift items                → FREE + strikethrough of original line total
       *   2. Line discount applied     → final + strikethrough original_line_price
       *      (set by /cart/update.js discount or by Shopify automatic discounts)
       *   3. Variant compare-at sale   → final + strikethrough (compare_at × qty)
       *      e.g. 10% off site-wide via compare_at_price in Shopify admin
       *   4. Nose-strips tier discount → final + strikethrough using local
       *      multiplier (Shopify's BXGY tier codes don't always reflect in
       *      cart.js — we apply visually here like we do for the gift mask)
       *   5. Regular price             → final only
       */
      var isGiftItem      = !!(item.properties && item.properties._g === '1');
      var hasLineDiscount = item.original_line_price && item.original_line_price > item.final_line_price;
      var hasCompareSale  = item.compare_at_price && item.compare_at_price > item.price;
      var compareLine     = hasCompareSale ? (item.compare_at_price * item.quantity) : 0;

      if (isGiftItem) {
        priceHtml = '<div class="hevo-cart-item__price hevo-cart-item__price--sale">' + (T.free || 'FREE') + '</div>' +
          '<div class="hevo-cart-item__price hevo-cart-item__price--compare">' + formatMoney(item.original_line_price) + '</div>';
      } else if (hasLineDiscount) {
        priceHtml = '<div class="hevo-cart-item__price hevo-cart-item__price--sale">' + formatMoney(item.final_line_price) + '</div>' +
          '<div class="hevo-cart-item__price hevo-cart-item__price--compare">' + formatMoney(item.original_line_price) + '</div>';
      } else if (hasCompareSale) {
        priceHtml = '<div class="hevo-cart-item__price hevo-cart-item__price--sale">' + formatMoney(item.final_line_price) + '</div>' +
          '<div class="hevo-cart-item__price hevo-cart-item__price--compare">' + formatMoney(compareLine) + '</div>';
      } else {
        priceHtml = '<div class="hevo-cart-item__price">' + formatMoney(item.final_line_price) + '</div>';
      }

      /* Wrap so _enhanceCompareSales can swap the price block in-place
         once it fetches the variant's compare_at_price (cart.js doesn't
         reliably surface it on line items, only via /products/:handle.js). */
      priceHtml = '<div class="hevo-cart-item__price-block">' + priceHtml + '</div>';

      /* Cost-per-night line — glasses only. Leads with the per-unit
         price + "=" so it reads unmistakably as a breakdown of the
         price the shopper already pays, not an extra charge.
         Per-unit price ÷ 365, framed over a year of evening use. */
      /* Replaced the cost-per-night breakdown with a scarcity line: a
         "limited sale" flag plus the real stock figure when it is low
         enough to matter. Stock comes from the same /products/:handle.js
         cache the stock pills already use, so no extra requests. */
      var perNightHtml = '';
      if (_isLensHandle(item.handle)) {
        perNightHtml = '<div class="hevo-cart-item__pernight">' +
          '<span class="hevo-cart-item__sale">' + T.limitedSale + '</span>' +
          '<span class="hevo-cart-item__stock" data-stock-for="' + item.variant_id + '"></span>' +
        '</div>';
        /* Fill the stock figure once the product JSON lands. */
        (function (it) {
          fetchProduct(it.handle).then(function (p) {
            if (!p) return;
            var v = null;
            for (var n = 0; n < p.variants.length; n++) {
              if (p.variants[n].id === it.variant_id) { v = p.variants[n]; break; }
            }
            if (!v || typeof v.inventory_quantity !== 'number') return;
            if (v.inventory_quantity <= 0 || v.inventory_quantity >= 15) return;
            var el = document.querySelector('[data-stock-for="' + it.variant_id + '"]');
            if (el) el.textContent = T.onlyLeft.replace('{count}', v.inventory_quantity);
          });
        })(item);
      }

      /* Gift items lock to qty 1 in the UI \u2014 +/- controls replaced
         with a static "GIFT" pill so users can't bump qty to abuse
         the 100%-off code. */

      var qtyHtml;
      if (isGiftItem) {
        qtyHtml =
          '<div class="hevo-cart-item__qty hevo-cart-item__qty--gift" aria-label="Free gift">' +
            '<span class="hevo-cart-item__gift-tag">' + (T.giftTag || 'GIFT') + '</span>' +
          '</div>';
      } else {
        qtyHtml =
          '<div class="hevo-cart-item__qty">' +
            '<button onclick="HevoCart.updateQty(' + (idx + 1) + ', ' + (item.quantity - 1) + ')" aria-label="Decrease">\u2212</button>' +
            '<span class="hevo-cart-item__qty-val">' + item.quantity + '</span>' +
            '<button onclick="HevoCart.updateQty(' + (idx + 1) + ', ' + (item.quantity + 1) + ')" aria-label="Increase">+</button>' +
          '</div>';
      }

      var pairNote = '';
      if (idx === _soloIdx) {
        var _unit = item.final_price || item.price;
        var _second = Math.round(_unit * (2 * BUNDLE_PCT / 100 - 1));
        var _lens = _lensOf(item.handle);
        /* Sleep and Relax both point at Focus; Focus points back at Sleep. */
        var _rec = (_lens === 'focus') ? T.pairRecSleep : T.pairRecFocus;
        pairNote =
          '<div class="hevo-pairnote">' +
            '<div class="hevo-pairnote__offer">' +
              T.pairAddOne.replace('{amount}', formatMoney(_second)) +
            '</div>' +
            '<div class="hevo-pairnote__rec">' + _rec + '</div>' +
          '</div>';
      }

      return '<div class="hevo-cart-item' + (isGiftItem ? ' hevo-cart-item--gift' : '') + '" data-line="' + (idx + 1) + '">' +
        '<img class="hevo-cart-item__img" src="' + imgSrc + '" alt="' + item.title + '" loading="lazy">' +
        '<div class="hevo-cart-item__details">' +
          '<div class="hevo-cart-item__top">' +
            '<div>' +
              '<div class="hevo-cart-item__name">' + item.product_title + '</div>' +
              variantHtml +
            '</div>' +
            /* Badge and stock sit under the price, not under the name: in the
               name column they added a third line and squeezed the title into
               three wrapped lines on mobile. */
            '<div class="hevo-cart-item__priceside">' + priceHtml + perNightHtml + '</div>' +
          '</div>' +
          '<div class="hevo-cart-item__actions">' +
            qtyHtml +
            '<button class="hevo-cart-item__remove" onclick="HevoCart.updateQty(' + (idx + 1) + ', 0)">' + T.remove + '</button>' +
          '</div>' +
        '</div>' +
        /* Outside __details on purpose: inside it the note started at the
           text column and stopped short of the image, so it read as belonging
           to the title rather than to the line. As a grid child spanning both
           columns it runs the full width of the drawer. */
        pairNote +
      '</div>';
    }).join('');
  }

  /* ── Upsell Discount (obfuscated) ── */
  var _ucs = {
    f: [86,79,65,45,57,49,55,50,50],
    s: [67,81,87,45,50,51,56,55,49],
    r: [89,82,84,45,53,51,50,49,57]
  };
  var _acp = [70,87,81,45,49,51,56,54,56];
  /* Nose Strips tier codes
   * 1 pack  → BNR-95407 (30%)
   * 3 packs → IQE-56319 (40%)
   * 5 packs → CXP-15371 (50%)
   */
  var _nst = {
    1: [66,78,82,45,57,53,52,48,55],
    3: [73,81,69,45,53,54,51,49,57],
    5: [67,88,80,45,49,53,51,55,49]
  };
  /* price multiplier shown in the cart upsell tier selector */
  var NS_TIERS = { 1: 0.70, 3: 0.60, 5: 0.50 };
  /* Free-mask / free-nose-strips gift codes (MUQ-47923 / NPM-15837)
     were retired 2026-05-03 — the 3rd-party gift app pushes its own
     discount when it adds the gift line, so the theme no longer holds
     the codes or pushes them itself. */
  function _guc(k) { return (_ucs[k]||[]).map(function(c){return String.fromCharCode(c)}).join(''); }
  function _gac() { return _acp.map(function(c){return String.fromCharCode(c)}).join(''); }
  function _gnst(qty) {
    if (qty < 1) return '';
    var t = qty >= 5 ? 5 : qty >= 3 ? 3 : 1;
    return (_nst[t]||[]).map(function(c){return String.fromCharCode(c)}).join('');
  }
  /*
   * Apply multiple discount codes at once.
   * Uses /cart/update.js with array, falling back to sequential /discount/ calls.
   */
  /*
   * Apply discount codes. Sends the COMPLETE set to /cart/update.js
   * which replaces all existing codes with the new set.
   */
  /* Cache the last-applied code set so repeat interactions (e.g. +/-
   * quantity on a lens that doesn't change the eligible codes) skip
   * the whole clear+apply cycle. */
  var _lastAppliedCodesKey = null;

  function _codesKey(codes) {
    return codes.slice().sort().join('|');
  }

  /* Apply the given codes and return the resulting cart so callers can
   * paint the correct post-sync state.
   *
   * Return value contract:
   *   null   → no network work was done (cache hit); caller's existing
   *            cartData is already correct.
   *   {cart} → discount state changed on the server; caller MUST replace
   *            cartData with this object before painting (otherwise stale
   *            prices from the pre-clear state will show). */
  function _applyDiscounts(codes) {
    var newKey = _codesKey(codes);
    var oldKey = _lastAppliedCodesKey;

    /* Skip only when we KNOW the cart already has this exact set applied.
     * Never skip on the very first call (key=null) — the session may hold
     * stale codes from a previous visit. */
    if (oldKey !== null && newKey === oldKey) {
      return Promise.resolve(null);
    }
    _lastAppliedCodesKey = newKey;

    /* Clear is only needed if something was previously applied. First-time
     * sync (oldKey=null) is conservative — assume the session may hold
     * stale codes from a previous visit → clear. Known-empty prior state
     * (oldKey='') means nothing to wipe → skip the 350ms triple-tap. */
    var needsClear = (oldKey === null) || (oldKey !== '');
    var clearP = needsClear ? _clearDiscounts() : Promise.resolve();

    /* Empty target set → just clear (if needed) and refetch cart. */
    if (!codes.length) {
      if (!needsClear) return Promise.resolve(null);
      return clearP.then(function() {
        return CartAPI.get();
      }).catch(function() { return null; });
    }

    return clearP.then(function() {
      var chain = Promise.resolve(null);
      codes.forEach(function(c, idx) {
        var isLast = idx === codes.length - 1;
        chain = chain.then(function() {
          return fetch('/discount/' + encodeURIComponent(c) + '?redirect=/cart.js', {
            method: 'GET',
            redirect: 'follow',
            credentials: 'same-origin'
          }).then(function(r) {
            /* Only parse the final response — it reflects all stacked codes. */
            if (isLast && r.ok) {
              return r.json().catch(function() { return null; });
            }
            return null;
          }).catch(function() { return null; });
        });
      });
      return chain;
    });
  }

  function _clearDiscounts() {
    /* Single POST to /cart/update.js {discount:''} only clears ONE code
     * slot. When codes are stacked via /discount/CODE fetches (which we
     * do for multi-code carts), MUQ-47923 / etc. will survive a single
     * clear and stay applied after the user removes the triggering item.
     *
     * Triple-tap is required:
     *   1. POST /cart/update.js {discount:''}
     *   2. GET  /discount/HEVO_CLEAR_0?redirect=/cart.js   (bogus code,
     *      forces Shopify to drop whatever's stacked in the session)
     *   3. POST /cart/update.js {discount:''}
     *
     * Each call is tiny (<150ms) because step 2 redirects to /cart.js
     * rather than the full /cart HTML. ~350ms total. */
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).catch(function(){}).then(function() {
      return fetch('/discount/HEVO_CLEAR_0?redirect=/cart.js', {
        method: 'GET',
        redirect: 'follow',
        credentials: 'same-origin'
      }).catch(function(){});
    }).then(function() {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      }).catch(function(){});
    });
  }

  /*
   * Master discount sync — collects ALL applicable codes and applies them together.
   * Shopify supports multiple discount codes simultaneously.
   *
   * Rules:
   * - Upsell lens (_u:'1') gets discount if a non-upsell lens is also in cart
   * - Nose strips qty >= 1 get tier discount (1-pack 30%, 3-pack 40%, 5-pack 50%)
   * - Other accessories with _a:'1' get accessory discount
   * - All applicable codes are applied at once (no priority — they stack)
   */
  /*
   * Compute all applicable discount codes from a list of cart items.
   * Can pass virtual "extra" items to simulate what codes would be needed
   * after an add (before the add actually completes).
   */
  function _computeCodes(items) {
    var codes = [];
    var nsGiftQty = 0;               /* nose-strips lines flagged as gift (_g:'1') */
    var nsPaidQty = 0;               /* nose-strips lines without the gift flag */
    var hasOtherAc = false;
    var maskInCart = false;
    var maskIsAccessoryFlow = false; /* user added it from "Optimera din sömn" */
    var glassesQty = 0;

    items.forEach(function(i) {
      var h = i.handle;
      var isLens = _isLensHandle(h);

      if (isLens) {
        glassesQty += i.quantity;
      }

      if (h === 'nose-strips-black') {
        if (i.properties && i.properties._g === '1') {
          nsGiftQty += i.quantity;
        } else {
          nsPaidQty += i.quantity;
        }
      } else if (h === 'sleep-mask') {
        maskInCart = true;
        if (i.properties && i.properties._a === '1') maskIsAccessoryFlow = true;
      } else if (i.properties && i.properties._a === '1') {
        hasOtherAc = true;
      }
    });

    /* Second-pair lens upsell:
     * The 20%-off second-pair discount is now handled by the AUTOMATIC
     * Shopify discount "SECOND PAIR" — it triggers whenever 2+ glasses
     * are in the cart, regardless of whether they were added via the
     * cart upsell or directly from a PDP. Pushing our old manual codes
     * (VOA-91722 / CQW-23871 / YRT-53219) here causes Shopify to swap
     * the automatic out, killing the discount in mixed flows. So we
     * leave the upsell flag in place (still useful for `_u:'1'`
     * tagging) but do NOT push a competing code. */
    /* The automatic upsell codes were removed: the nose-strips tiers
       (BNR-95407 / IQE-56319 / CXP-15371) and the accessory code
       (FWQ-13868). Nothing is pushed for accessories any more — only
       codes the customer typed themselves ride along below. */
    /* Fold in customer-typed manual codes so they ride along through the
       clear+reapply cycle and get carried to the checkout URL. */
    _manualCodes.forEach(function(c) {
      if (codes.indexOf(c) === -1) codes.push(c);
    });
    return codes;
  }

  /* True if `code` shows up as an applied discount in the given cart —
     checks both order/cart-level applications and per-line allocations,
     covering order, product, and shipping discount types. */
  function _codeIsApplied(cart, code) {
    if (!cart || !code) return false;
    var up = String(code).toUpperCase();
    var apps = cart.cart_level_discount_applications || [];
    for (var i = 0; i < apps.length; i++) {
      if ((apps[i].title || '').toUpperCase() === up) return true;
    }
    var items = cart.items || [];
    for (var j = 0; j < items.length; j++) {
      var das = items[j].discount_allocations || [];
      for (var k = 0; k < das.length; k++) {
        var t = das[k].discount_application && das[k].discount_application.title;
        if ((t || '').toUpperCase() === up) return true;
      }
    }
    return false;
  }

  function _syncDiscounts() {
    var items = cartData ? cartData.items : [];
    if (!items.length) { _clearDiscounts(); _lastAppliedCodesKey = ''; return; }

    var codes = _computeCodes(items);
    return _applyDiscounts(codes).then(function(finalCart) {
      if (finalCart && finalCart.items) {
        cartData = finalCart;
        _paintCart();
      }
      /* else: codes unchanged (cache hit), cartData already correct. */
    });
  }

  /* Gift integrity check, two jobs:
   *   1. If glasses dropped below 2 → remove gift-flow lines.
   *   2. Cap any gift-flow line quantity at 1 (the discount code only
   *      makes 1 item free per order, but Shopify zeros the whole line
   *      regardless of qty — so a sneaky user could bump qty and get
   *      multiples free unless we clamp it here).
   *
   * Items added through non-gift paths (PDP purchase, regular accessory
   * upsell) keep their natural quantity behavior. */
  function _enforceGiftEligibility(cart) {
    if (!cart || !cart.items) return Promise.resolve(cart);
    var glassesQty = 0;
    var giftLines = [];   /* {line, qty} */
    cart.items.forEach(function(i, idx) {
      var h = i.handle;
      if (_isLensHandle(h)) {
        glassesQty += i.quantity;
      }
      if ((h === 'sleep-mask' || h === 'nose-strips-black')
          && i.properties && i.properties._g === '1') {
        giftLines.push({ line: idx + 1, qty: i.quantity });
      }
    });
    if (!giftLines.length) return Promise.resolve(cart);

    var ineligible = glassesQty < 2;

    /* Sort high → low so earlier indices stay valid through any removals */
    giftLines.sort(function(a, b) { return b.line - a.line; });

    var chain = Promise.resolve(cart);
    giftLines.forEach(function(g) {
      if (ineligible) {
        chain = chain.then(function() { return CartAPI.change(g.line, 0); });
      } else if (g.qty > 1) {
        /* Eligible but quantity got bumped — clamp to 1 */
        chain = chain.then(function() { return CartAPI.change(g.line, 1); });
      }
    });
    return chain;
  }

  /* Add-to-cart helper. Safely parallelizes where possible:
   *
   *   · Pre-compute target codes from predicted post-add cart (cartData
   *     + the new line) — no /cart.js fetch needed up front.
   *   · Fire /cart/add.js AND _clearDiscounts concurrently (they touch
   *     independent server state: cart lines vs. session discount slot).
   *   · WAIT for /cart/add.js to commit BEFORE firing /discount/CODE
   *     calls — otherwise Shopify evaluates the discount against the
   *     pre-add cart and silently rejects codes that depend on the new
   *     line (e.g. VOA-91722 only attaches when both lens types are
   *     present). This was the "upsell code not auto-applied" bug.
   *   · Use the last /discount/?redirect=/cart.js response as the final
   *     cart — one less /cart.js fetch.
   *
   * Cache-short-circuit when target codes match the currently-applied set:
   * skip clear + /discount/ entirely, just add + fetch + paint. */
  function _addThenSync(variantId, qty, properties, handle) {
    qty = qty || 1;

    /* No handle → can't predict. Fall back to safe sequential path. */
    if (!handle) {
      return CartAPI.add(variantId, qty, properties).then(function() {
        return CartAPI.get();
      }).then(function(cart) {
        cartData = cart;
        var c = _computeCodes(cart.items);
        return _applyDiscounts(c).then(function(finalCart) {
          if (finalCart && finalCart.items) cartData = finalCart;
        });
      }).then(function() { _paintCart(); });
    }

    var predictedItems = (cartData && cartData.items ? cartData.items.slice() : []);
    predictedItems.push({ handle: handle, quantity: qty, properties: properties || {} });
    var codes = _computeCodes(predictedItems);
    var newKey = _codesKey(codes);
    var oldKey = _lastAppliedCodesKey;

    /* Codes unchanged — no discount work needed, just add + fetch + paint. */
    if (oldKey !== null && newKey === oldKey) {
      return CartAPI.add(variantId, qty, properties)
        .then(function() { return CartAPI.get(); })
        .then(function(cart) { cartData = cart; _paintCart(); });
    }

    /* Codes will change. Commit the new key so concurrent syncs don't re-clear. */
    _lastAppliedCodesKey = newKey;
    var needsClear = oldKey === null || oldKey !== '';
    var addP = CartAPI.add(variantId, qty, properties);
    var clearP = needsClear ? _clearDiscounts() : Promise.resolve();

    /* Wait for /cart/add.js AND clear BEFORE applying new codes. */
    return Promise.all([addP, clearP]).then(function() {
      if (!codes.length) {
        return CartAPI.get().then(function(cart) { cartData = cart; });
      }
      var chain = Promise.resolve(null);
      codes.forEach(function(c, idx) {
        var isLast = idx === codes.length - 1;
        chain = chain.then(function() {
          return fetch('/discount/' + encodeURIComponent(c) + '?redirect=/cart.js', {
            method: 'GET',
            redirect: 'follow',
            credentials: 'same-origin'
          }).then(function(r) {
            if (isLast && r.ok) return r.json().catch(function() { return null; });
            return null;
          }).catch(function() { return null; });
        });
      });
      return chain.then(function(lastCart) {
        if (lastCart && lastCart.items) {
          cartData = lastCart;
        } else {
          return CartAPI.get().then(function(cart) { cartData = cart; });
        }
      });
    }).then(function() {
      _paintCart();
    });
  }

  /* Batched version of _addThenSync — adds multiple items in ONE
     /cart/add.js call and runs the discount sync once. Used by the
     gift bundle (mask + nose strips) so the user waits one round-trip
     instead of two. */
  function _addBatchThenSync(itemsList) {
    if (!itemsList || !itemsList.length) return Promise.resolve();

    var apiItems = itemsList.map(function(i) {
      return { id: i.id, quantity: i.quantity || 1, properties: i.properties };
    });

    /* Predict post-add cart so we know which codes to push. */
    var predictedItems = (cartData && cartData.items ? cartData.items.slice() : []);
    itemsList.forEach(function(i) {
      predictedItems.push({
        handle: i.handle,
        quantity: i.quantity || 1,
        properties: i.properties || {}
      });
    });

    var codes = _computeCodes(predictedItems);
    var newKey = _codesKey(codes);
    var oldKey = _lastAppliedCodesKey;

    /* Codes unchanged — single batch add + refetch + paint. */
    if (oldKey !== null && newKey === oldKey) {
      return CartAPI.addBatch(apiItems)
        .then(function() { return CartAPI.get(); })
        .then(function(cart) { cartData = cart; _paintCart(); });
    }

    _lastAppliedCodesKey = newKey;
    var needsClear = oldKey === null || oldKey !== '';
    var addP = CartAPI.addBatch(apiItems);
    var clearP = needsClear ? _clearDiscounts() : Promise.resolve();

    return Promise.all([addP, clearP]).then(function() {
      if (!codes.length) {
        return CartAPI.get().then(function(cart) { cartData = cart; });
      }
      var chain = Promise.resolve(null);
      codes.forEach(function(c, idx) {
        var isLast = idx === codes.length - 1;
        chain = chain.then(function() {
          return fetch('/discount/' + encodeURIComponent(c) + '?redirect=/cart.js', {
            method: 'GET',
            redirect: 'follow',
            credentials: 'same-origin'
          }).then(function(r) {
            if (isLast && r.ok) return r.json().catch(function() { return null; });
            return null;
          }).catch(function() { return null; });
        });
      });
      return chain.then(function(lastCart) {
        if (lastCart && lastCart.items) {
          cartData = lastCart;
        } else {
          return CartAPI.get().then(function(cart) { cartData = cart; });
        }
      });
    }).then(function() {
      _paintCart();
    });
  }

  /* ── Lens Upsell Logic ── */
  var FRAME_COLORS = {
    'ceres': ['black', 'transparent'],
    'helios': ['black', 'transparent', 'grey']
  };

  function getLensUpsellHandles(items) {
    var upsells = [];
    var cartHandles = items.map(function(i) { return i.handle; });

    items.forEach(function(item) {
      var handle = item.handle;
      /* Skip accessories up front — `mouth-sleep-tape` would otherwise
         match the `-sleep-` substring and parse as a sleep lens. */
      if (!_isLensHandle(handle)) return;
      var lensType = handle.indexOf('-sleep-') !== -1 ? 'sleep' :
                     handle.indexOf('-focus-') !== -1 ? 'focus' :
                     handle.indexOf('-relax-') !== -1 ? 'relax' : '';
      if (!lensType) return;

      var targetLens = lensType === 'sleep' ? 'focus' : lensType === 'focus' ? 'sleep' : 'focus';

      /* Parse frame and color from handle: {frame}-{color}-{lens}-lens */
      var parts = handle.split('-');
      var lensIdx = parts.indexOf(lensType);
      var frame = parts.slice(0, lensIdx - 1).join('-');
      var color = parts[lensIdx - 1];

      /* Same-color swap (always first) */
      var sameColorHandle = handle.replace('-' + lensType + '-', '-' + targetLens + '-');
      if (cartHandles.indexOf(sameColorHandle) === -1) {
        upsells.push({ handle: sameColorHandle, originalHandle: handle });
      }

      /* Multi-color variants for ceres and helios */
      var colors = FRAME_COLORS[frame];
      if (colors) {
        colors.forEach(function(c) {
          if (c === color) return;
          var altHandle = frame + '-' + c + '-' + targetLens + '-lens';
          if (cartHandles.indexOf(altHandle) === -1) {
            upsells.push({ handle: altHandle, originalHandle: handle });
          }
        });
      }
    });

    var seen = {};
    return upsells.filter(function(u) {
      if (seen[u.handle]) return false;
      seen[u.handle] = true;
      return true;
    }).slice(0, 4);
  }

  function renderUpsells(items) { return; /* replaced by hevo-2nd-pair */
    var section = document.getElementById('hevoUpsellSection');
    var grid = document.getElementById('hevoUpsellGrid');

    var hasUpsellItem = items.some(function(i) { return i.properties && i.properties._u === '1'; });
    if (hasUpsellItem) {
      section.style.display = 'none';
      return;
    }

    var upsellHandles = getLensUpsellHandles(items);

    if (upsellHandles.length === 0) {
      section.style.display = 'none';
      return;
    }

    Promise.all(
      upsellHandles.map(function(u) {
        return fetchProduct(u.handle).then(function(p) {
          return p ? Object.assign({}, p, { _upsellHandle: u.handle }) : null;
        });
      })
    ).then(function(products) {
      var validProducts = products.filter(function(p) { return p && p.available; });

      if (validProducts.length === 0) {
        section.style.display = 'none';
        return;
      }

      section.style.display = 'block';

      /* Title: replace the generic "Complete your collection" with a
         usage-clear headline based on which lens type is being upsold,
         so the shopper sees what the suggested lens is FOR. */
      var titleEl = document.getElementById('hevoUpsellTitle');
      if (titleEl) {
        var h0 = validProducts[0]._upsellHandle || validProducts[0].handle || '';
        var titleKey = (h0.indexOf('-sleep-') !== -1) ? 'upsellTitleSleep'
                     : (h0.indexOf('-focus-') !== -1) ? 'upsellTitleFocus'
                     : (h0.indexOf('-relax-') !== -1) ? 'upsellTitleRelax' : '';
        titleEl.textContent = (titleKey && T[titleKey]) ? T[titleKey] : T.upsellTitle;
      }

      /* Subtitle: "save {amount} — 30% off both pairs". Total savings
         across both pairs = 30% × (existing pair + cheapest upsell),
         which is the minimum the customer would save by adding any
         second pair. */
      var subEl = document.getElementById('hevoUpsellSub');
      if (subEl) {
        var existingGlass = items.filter(function(i) {
          return _isLensHandle(i.handle);
        })[0];
        if (existingGlass) {
          var existingPrice  = existingGlass.original_price || existingGlass.price || 0;
          var cheapestUpsell = validProducts.reduce(function(min, p) {
            var price = p.compare_at_price || p.price;
            return (min === null || price < min) ? price : min;
          }, null);
          var totalSavings = Math.round((existingPrice + (cheapestUpsell || existingPrice)) * 0.30);
          subEl.innerHTML = (T.upsellSub || '').replace('{amount}', formatMoney(totalSavings));
        } else {
          subEl.innerHTML = '';
        }
      }

      grid.innerHTML = validProducts.map(function(p) {
        var variant = p.variants[0];
        var img = p.images[0] || '';
        var imgSrc = img ? img.replace(/(\.[^.]+)$/, '_160x160$1') : '';
        var originalPrice = p.compare_at_price || p.price;
        var discounted = Math.round(originalPrice * 0.70);

        return '<div class="hevo-upsell-card">' +
          '<img class="hevo-upsell-card__img" src="' + imgSrc + '" alt="' + p.title + '" loading="lazy">' +
          '<div class="hevo-upsell-card__info">' +
            '<div class="hevo-upsell-card__name">' + p.title + '</div>' +
            '<div class="hevo-upsell-card__price-line">' +
              '<span class="hevo-upsell-card__price hevo-upsell-card__price--sale">' + formatMoney(discounted) + '</span>' +
              '<span class="hevo-upsell-card__badge">-30%</span>' +
            '</div>' +
            '<div class="hevo-upsell-card__bottom">' +
              '<span class="hevo-upsell-card__price hevo-upsell-card__price--compare">' + formatMoney(originalPrice) + '</span>' +
              '<button class="hevo-upsell-card__add" onclick="HevoCart.addUpsell(' + variant.id + ', this, \'' + p._upsellHandle + '\')" data-variant="' + variant.id + '">' + T.addBtn + '</button>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');
    });
  }

  /* ── Accessories Recommendations ── */
  function renderAccessories(items) {
    var section = document.getElementById('hevoRecsSection');
    var scroll = document.getElementById('hevoRecsScroll');

    var hasGlasses = items.some(function(i) {
      return _isLensHandle(i.handle);
    });

    var nsInCart = items.some(function(i) { return i.handle === 'nose-strips-black'; });

    /* The mask's 35% is a Shopify automatic Buy-X-Get-Y: one discounted mask
       per pair of glasses. Measured 2026-08-26 — 1 pair discounts 1 of 3
       masks, 2 pairs discount 2 of 5. So the stepper stops at the glasses
       count; past that the card would quote a price checkout won't honour. */
    var glassesQty = items.reduce(function(a, i) {
      return a + (_isLensHandle(i.handle) ? i.quantity : 0);
    }, 0);
    window._hevoMaskMax = Math.max(1, glassesQty);

    /* Only show accessories when glasses are in cart */
    if (!hasGlasses) {
      section.style.display = 'none';
      return;
    }

    /* Hide accessory upsell ONLY if a non-gift line for it already exists.
     * Gift-flagged lines (_g:'1') don't count — user can still purchase
     * additional units at the tier/accessory discount on top of the free
     * gift one. So if user claimed free nose strips, the upsell stays
     * visible and they can buy 1× / 3× / 5× packs at tier pricing. */
    var paidHandles = items
      .filter(function(i) { return !(i.properties && i.properties._g === '1'); })
      .map(function(i) { return i.handle; });
    /* Accessories stay listed after they are added — the card disappearing
       mid-session read as the offer being withdrawn. Adding again increments
       the existing line. `paidHandles` is still computed above for the gift
       logic further down. */
    var toShow = CONFIG.accessories.slice();

    if (toShow.length === 0) {
      section.style.display = 'none';
      return;
    }

    Promise.all(
      toShow.map(function(h) { return fetchProduct(h); })
    ).then(function(products) {
      var cards = [];

      products.forEach(function(p) {
        if (!p || !p.available) return;
        var variant = p.variants[0];
        var imgSrc = (p.images[0] || '').replace(/(\.[^.]+)$/, '_160x160$1');

        /* Nose strips get tier selector card */
        if (p.handle === 'nose-strips-black') {
          cards.push(
            '<div class="hevo-rec-card hevo-rec-card--ns">' +
              '<img class="hevo-rec-card__img" src="' + imgSrc + '" alt="' + p.title + '" loading="lazy">' +
              '<div class="hevo-rec-card__main">' +
                '<div class="hevo-rec-card__name">' + p.title + '</div>' +
                '<div class="hevo-rec-card__price-row" id="hevoNsPrice">' +
                  '<span class="hevo-rec-card__price-line">' +
                    '<span class="hevo-rec-card__price--sale">' + formatMoney(Math.round(p.price * 0.70)) + '</span>' +
                    '<span class="hevo-rec-card__badge">-30%</span>' +
                  '</span>' +
                  '<span class="hevo-rec-card__price--compare">' + formatMoney(p.price) + '</span>' +
                '</div>' +
              '</div>' +
              '<div class="hevo-rec-card__right">' +
                '<button class="hevo-rec-card__add" id="hevoNsAddBtn" onclick="HevoCart.addAccessory(' + variant.id + ', this, \'nose-strips-black\', window._hevoNsQty || 1)">' + T.addBtn + '</button>' +
              '</div>' +
              '<div class="hevo-ns-tiers" id="hevoNsTiers">' +
                '<button class="hevo-ns-tier is-active" data-qty="1" onclick="HevoCart._selectNsTier(1,' + p.price + ')">' +
                  '<span class="hevo-ns-tier__qty">1x</span>' +
                  '<span class="hevo-ns-tier__pct">-30%</span>' +
                '</button>' +
                '<button class="hevo-ns-tier" data-qty="3" onclick="HevoCart._selectNsTier(3,' + p.price + ')">' +
                  '<span class="hevo-ns-tier__qty">3x</span>' +
                  '<span class="hevo-ns-tier__pct">-40%</span>' +
                '</button>' +
                '<button class="hevo-ns-tier" data-qty="5" onclick="HevoCart._selectNsTier(5,' + p.price + ')">' +
                  '<span class="hevo-ns-tier__qty">5x</span>' +
                  '<span class="hevo-ns-tier__pct">-50%</span>' +
                '</button>' +
              '</div>' +
            '</div>'
          );
          return;
        }

        /* Sleep mask: 35% off, with a plain quantity stepper. No tiers —
           the rate does not move with quantity the way nose strips do. */
        if (p.handle === 'sleep-mask') {
          window._hevoMaskQty = 1;
          cards.push(
            '<div class="hevo-rec-card hevo-rec-card--mask">' +
              '<img class="hevo-rec-card__img" src="' + imgSrc + '" alt="' + p.title + '" loading="lazy">' +
              '<div class="hevo-rec-card__main">' +
                '<div class="hevo-rec-card__name">' + p.title + '</div>' +
                '<div class="hevo-rec-card__price-row" id="hevoMaskPrice">' +
                  '<span class="hevo-rec-card__price-line">' +
                    '<span class="hevo-rec-card__price--sale">' + formatMoney(Math.round(p.price * 0.65)) + '</span>' +
                    '<span class="hevo-rec-card__badge">-35%</span>' +
                  '</span>' +
                  '<span class="hevo-rec-card__price--compare">' + formatMoney(p.price) + '</span>' +
                '</div>' +
              '</div>' +
              '<div class="hevo-rec-card__right">' +
                '<button class="hevo-rec-card__add" onclick="HevoCart.addAccessory(' + variant.id + ', this, \'sleep-mask\', 1)">' + T.addBtn + '</button>' +
              '</div>' +
            '</div>'
          );
          return;
        }

        /* Standard accessory card — plain price, no badge and no struck
           compare. The -20% it used to advertise was never applied at
           checkout (verified 2026-08-26: mouth-sleep-tape quoted 180, charged
           225), so the card now quotes what the customer actually pays. */
        cards.push(
          '<div class="hevo-rec-card">' +
            '<img class="hevo-rec-card__img" src="' + imgSrc + '" alt="' + p.title + '" loading="lazy">' +
            '<div class="hevo-rec-card__main">' +
              '<div class="hevo-rec-card__name">' + p.title + '</div>' +
              '<div class="hevo-rec-card__price-row">' +
                '<span class="hevo-rec-card__price--plain">' + formatMoney(p.price) + '</span>' +
              '</div>' +
            '</div>' +
            '<div class="hevo-rec-card__right">' +
              '<button class="hevo-rec-card__add" onclick="HevoCart.addAccessory(' + variant.id + ', this, \'' + p.handle + '\')">' + T.addBtn + '</button>' +
            '</div>' +
          '</div>'
        );
      });

      if (cards.length === 0) {
        section.style.display = 'none';
        return;
      }

      section.style.display = 'block';
      scroll.innerHTML = cards.join('');
    });
  }

  /* renderGift removed 2026-05-11 — the free Sleep Mask gift strip was
     dropped from the cart drawer per merchant request. */

  var _displayTotal = null;

  function renderTotal(cart) {
    /* Buy X Get Y / tier discounts often don't reflect in cart.js until
       checkout. We visually subtract them here so the total + savings
       line match what we render on each line item. */
    var giftSavings   = 0;
    /* The nose-strips tier discount was visual only — it anticipated the
       BNR/IQE/CXP codes. Those are gone, so subtracting it here would show a
       total Shopify will not charge. */
    var nsTierSavings = 0;

    (cart.items || []).forEach(function(i) {
      var isGiftItem = i.properties && i.properties._g === '1';
      if (isGiftItem && i.final_line_price > 0) {
        giftSavings += i.final_line_price;
        return;
      }
    });

    var visualSavingsOverride = giftSavings + nsTierSavings;
    var displayTotal = Math.max(0, cart.total_price - visualSavingsOverride);
    document.getElementById('hevoCartTotal').textContent = formatMoney(displayTotal);
    document.getElementById('hevoCartCount').textContent = cart.item_count;

    var badges = document.querySelectorAll('.cart-count, [data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = cart.item_count;
    }

    /* Show total saved (Shopify line-discount savings + visual overrides) */
    var savedEl = document.getElementById('hevoCartSaved');
    var originalTotal = cart.original_total_price || 0;
    var savings = (originalTotal - cart.total_price) + visualSavingsOverride;
    /* Shared with _enhanceCompareSales, which refines both of these once the
       real compare_at_price lands from /products/:handle.js. */
    _displayTotal = displayTotal;
    /* Struck pre-discount total, so the saving is shown as a price the
       shopper can compare against rather than only as an abstract amount. */
    var cmpEl = document.getElementById('hevoCartCompare');
    if (savings > 0) {
      savedEl.textContent = T.saved.replace('{amount}', formatMoney(savings));
      savedEl.style.display = 'block';
      if (cmpEl) {
        cmpEl.textContent = formatMoney(displayTotal + savings);
        cmpEl.style.display = 'inline';
      }
    } else {
      savedEl.style.display = 'none';
      if (cmpEl) cmpEl.style.display = 'none';
    }

    /* Pass ALL applicable discount codes to the checkout URL so Shopify
       guarantees they all apply at checkout — even if the cart-drawer
       /discount/CODE push silently dropped some (which can happen when
       Buy X Get Y stacks with product discounts and combinations are
       borderline). This is the bulletproof safety net. */
    var checkoutBtn = document.getElementById('hevoCheckoutBtn');
    if (checkoutBtn) {
      var allCodes = _computeCodes(cart.items || []);
      checkoutBtn.href = allCodes.length
        ? '/checkout?discount=' + allCodes.map(encodeURIComponent).join(',')
        : '/checkout';
    }
  }

  /* Render the removable chips for each manually-applied code. Internal
     automatic codes (nose-strips tiers etc.) are never shown here. */
  function renderManualChips() {
    var wrap = document.getElementById('hevoDiscountChips');
    if (!wrap) return;
    if (!_manualCodes.length) { wrap.innerHTML = ''; return; }
    var x = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 18L18 6M6 6l12 12"/></svg>';
    wrap.innerHTML = _manualCodes.map(function(c) {
      var safe = c.replace(/'/g, "\\'");
      return '<span class="hevo-discount__chip">' + c +
        '<button type="button" aria-label="' + (T.discountRemove || 'Remove') +
        '" onclick="HevoCart.removeManualDiscount(\'' + safe + '\')">' + x + '</button></span>';
    }).join('');
  }

  /* ──────────────── MAIN RENDER ──────────────── */
  /* Paint from the current cartData — no network work. */
  function _paintCart() {
    if (!cartData) return;
    renderCartItems(cartData.items);
    renderShippingBar(cartData.total_price);
    renderTotal(cartData);
    renderUpsells(cartData.items);
    renderAccessories(cartData.items);
    renderManualChips();
    _enhanceStockPills(cartData.items);
    _enhanceCompareSales(cartData.items);
  }

  /* Fetch fresh cart + paint. Used when cartData may be stale. */
  function renderCart() {
    return CartAPI.get().then(function(cart) {
      cartData = cart;
      _paintCart();
    });
  }

  /* ──────────────── PUBLIC API ──────────────── */
  window.HevoCart = {
    open: function() {
      renderCart().then(function() {
        /* Only sync if cart has discountable items — avoids unnecessary calls */
        if (cartData && cartData.items && cartData.items.length > 0) {
          _syncDiscounts();
        }
      });
      document.getElementById('hevoCartDrawer').classList.add('is-open');
      document.getElementById('hevoCartOverlay').classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    },

    close: function() {
      document.getElementById('hevoCartDrawer').classList.remove('is-open');
      document.getElementById('hevoCartOverlay').classList.remove('is-visible');
      document.body.style.overflow = '';
    },

    updateQty: function(line, qty) {
      var item = document.querySelector('.hevo-cart-item[data-line="' + line + '"]');
      if (item) item.classList.add('hevo-cart-item--loading');
      /* /cart/change.js already returns the full updated cart — no
       * need for a separate /cart.js fetch. Single-paint pattern. */
      CartAPI.change(line, qty).then(function(cart) {
        /* If qty change dropped glasses below 2, auto-remove the gift
         * mask so the user isn't left paying for it. */
        return _enforceGiftEligibility(cart);
      }).then(function(cart) {
        cartData = cart;
        var codes = _computeCodes(cart.items);
        return _applyDiscounts(codes).then(function(finalCart) {
          if (finalCart && finalCart.items) cartData = finalCart;
        });
      }).then(function() {
        _paintCart();
      }).catch(function(err) {
        console.error('updateQty failed:', err);
        if (item) item.classList.remove('hevo-cart-item--loading');
      });
    },

    addToCart: function(variantId, btn) {
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.innerHTML = '<span class="hevo-spinner"></span>';

      CartAPI.add(variantId).then(function() {
        return renderCart();
      }).then(function() {
        btn.textContent = T.addedBtn;
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      });
    },

    addUpsell: function(variantId, btn, handle) {
      if (btn.disabled) return;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.innerHTML = '<span class="hevo-spinner"></span>';

      /* Tag with `_u:'1'` so the upsell section hides once an upsell
         lens is in the cart. The flag does NOT trigger any manual code
         — SECOND PAIR is the automatic discount handling the 20% off. */
      _addThenSync(variantId, 1, { '_u': '1' }, handle).then(function() {
        btn.textContent = '\u2713';
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      }).catch(function(err) {
        console.error('addUpsell failed:', err);
        btn.textContent = originalText;
        btn.disabled = false;
      });
    },

    /* addGift / addAllGifts removed 2026-05-03 \u2014 the 3rd-party gift app
       owns the entire free-mask flow. The drawer no longer adds, removes,
       or flags any line with `_g:'1'` itself. */

    addAccessory: function(variantId, btn, handle, qty) {
      if (btn.disabled) return;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.innerHTML = '<span class="hevo-spinner"></span>';

      _addThenSync(variantId, qty || 1, { '_a': '1' }, handle).then(function() {
        btn.textContent = '\u2713';
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      }).catch(function(err) {
        console.error('addAccessory failed:', err);
        btn.textContent = originalText;
        btn.disabled = false;
      });
    },

    _upgradeNs: function(line, qty, unitPrice) {
      /* Update tier button visuals immediately */
      var tiers = document.querySelectorAll('.hevo-ns-tier');
      for (var i = 0; i < tiers.length; i++) {
        tiers[i].classList.toggle('is-active', parseInt(tiers[i].getAttribute('data-qty')) === qty);
      }
      /* 1x = -30%, 3x = -40%, 5x = -50% */
      var pct = qty >= 5 ? 50 : qty >= 3 ? 40 : 30;
      var disc = Math.round(unitPrice * qty * (1 - pct / 100));
      var orig = unitPrice * qty;
      var priceEl = document.getElementById('hevoNsPrice');
      if (priceEl) {
        priceEl.innerHTML =
          '<span class="hevo-rec-card__price-line">' +
            '<span class="hevo-rec-card__price--sale">' + formatMoney(disc) + '</span>' +
            '<span class="hevo-rec-card__badge">-' + pct + '%</span>' +
          '</span>' +
          '<span class="hevo-rec-card__price--compare">' + formatMoney(orig) + '</span>';
      }
      /* Update cart line quantity */
      CartAPI.change(line, qty).then(function() {
        return renderCart();
      }).then(function() {
        _syncDiscounts();
      });
    },

    _selectNsTier: function(qty, unitPrice) {
      window._hevoNsQty = qty;
      var tiers = document.querySelectorAll('.hevo-ns-tier');
      for (var i = 0; i < tiers.length; i++) {
        tiers[i].classList.toggle('is-active', parseInt(tiers[i].getAttribute('data-qty')) === qty);
      }
      /* 1x = -30%, 3x = -40%, 5x = -50% */
      var multiplier = qty >= 5 ? 0.50 : qty >= 3 ? 0.60 : 0.70;
      var pct        = qty >= 5 ? 50   : qty >= 3 ? 40   : 30;
      var disc = Math.round(unitPrice * qty * multiplier);
      var orig = unitPrice * qty;
      var priceEl = document.getElementById('hevoNsPrice');
      if (priceEl) {
        priceEl.innerHTML =
          '<span class="hevo-rec-card__price-line">' +
            '<span class="hevo-rec-card__price--sale">' + formatMoney(disc) + '</span>' +
            '<span class="hevo-rec-card__badge">-' + pct + '%</span>' +
          '</span>' +
          '<span class="hevo-rec-card__price--compare">' + formatMoney(orig) + '</span>';
      }
    },

    /* Plain +/- stepper for the sleep mask. Flat 35%, so only the amounts
       scale with quantity — the rate and badge stay put. */
    _maskQty: function(delta, unitPrice) {
      var max = window._hevoMaskMax || 1;
      var qty = Math.min(max, Math.max(1, (window._hevoMaskQty || 1) + delta));
      window._hevoMaskQty = qty;
      var valEl = document.getElementById('hevoMaskQtyVal');
      if (valEl) valEl.textContent = qty;
      var priceEl = document.getElementById('hevoMaskPrice');
      if (priceEl) {
        priceEl.innerHTML =
          '<span class="hevo-rec-card__price-line">' +
            '<span class="hevo-rec-card__price--sale">' + formatMoney(Math.round(unitPrice * qty * 0.65)) + '</span>' +
            '<span class="hevo-rec-card__badge">-35%</span>' +
          '</span>' +
          '<span class="hevo-rec-card__price--compare">' + formatMoney(unitPrice * qty) + '</span>';
      }
      var row = document.querySelector('.hevo-qty');
      if (row) {
        var btns = row.querySelectorAll('.hevo-qty__btn');
        if (btns[0]) btns[0].disabled = qty <= 1;
        if (btns[1]) btns[1].disabled = qty >= max;
      }
    },

    /* toggleDiscount / applyDiscount removed 2026-05-03 — the in-drawer
       apply form was replaced with a static "codes apply at checkout"
       note. Customers enter codes in the native checkout discount field. */

    /* One card per step. The cards are full-width and snap, so a fixed
       180px nudge fought the snap (it bounced back or skipped). Step to the
       next card's own offset instead, and stop at the ends. */
    scrollRecs: function(dir) {
      var scroll = document.getElementById('hevoRecsScroll');
      if (!scroll || !scroll.children.length) return;
      var cards = scroll.children, base = cards[0].offsetLeft, cur = 0, best = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs(cards[i].offsetLeft - base - scroll.scrollLeft);
        if (dist < best) { best = dist; cur = i; }
      }
      var next = Math.max(0, Math.min(cards.length - 1, cur + dir));
      scroll.scrollTo({ left: cards[next].offsetLeft - base, behavior: 'smooth' });
    },

    /* Arrows: hidden with a single card, dimmed at either end. */
    updateRecsNav: function() {
      var scroll = document.getElementById('hevoRecsScroll');
      var nav = document.querySelector('.hevo-recs__nav');
      if (!scroll || !nav) return;
      var btns = nav.querySelectorAll('button');
      var many = scroll.children.length > 1;
      nav.hidden = !many;
      if (!many || btns.length < 2) return;
      var max = scroll.scrollWidth - scroll.clientWidth;
      btns[0].disabled = scroll.scrollLeft <= 4;
      btns[1].disabled = scroll.scrollLeft >= max - 4;
    },

    /* Expand / collapse the discount input. */
    toggleDiscount: function() {
      var section = document.getElementById('hevoDiscountSection');
      var body    = document.getElementById('hevoDiscountBody');
      var toggle  = document.getElementById('hevoDiscountToggle');
      if (!section || !body) return;
      var willOpen = body.hasAttribute('hidden');
      if (willOpen) {
        body.removeAttribute('hidden');
        section.classList.add('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
        var input = document.getElementById('hevoDiscountInput');
        if (input) input.focus();
      } else {
        body.setAttribute('hidden', '');
        section.classList.remove('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    },

    /* Apply a customer-typed discount code and refresh the drawer prices
       immediately. The code is added to _manualCodes, the full code set
       is re-applied server-side, and we validate that the code actually
       took effect (total dropped OR it appears in the cart's discount
       applications). Invalid codes are rolled back and an error shown. */
    applyManualDiscount: function(e) {
      if (e && e.preventDefault) e.preventDefault();
      var input = document.getElementById('hevoDiscountInput');
      var btn   = document.getElementById('hevoDiscountBtn');
      var msg   = document.getElementById('hevoDiscountMsg');
      if (!input || !btn) return false;

      var raw = (input.value || '').trim();
      if (!raw) return false;
      var code = raw.toUpperCase();

      if (msg) { msg.textContent = ''; msg.className = 'hevo-discount__msg'; }

      /* Already added — no-op with a gentle notice. */
      if (_manualCodes.indexOf(code) !== -1) {
        if (msg) { msg.textContent = T.discountAlready; msg.className = 'hevo-discount__msg is-error'; }
        return false;
      }

      var totalBefore = cartData ? cartData.total_price : 0;
      var originalLabel = btn.textContent;
      btn.disabled = true;
      btn.innerHTML = '<span class="hevo-spinner"></span>';

      _manualCodes.push(code);
      _persistManualCodes();
      /* Bust the cache so the clear+reapply definitely runs. */
      _lastAppliedCodesKey = null;

      var targetCodes = _computeCodes(cartData ? cartData.items : []);
      _applyDiscounts(targetCodes).then(function(finalCart) {
        if (finalCart && finalCart.items) cartData = finalCart;
        var cart = cartData;
        var applied = cart && (cart.total_price < totalBefore || _codeIsApplied(cart, code));

        if (applied) {
          input.value = '';
          if (msg) { msg.textContent = T.discountApplied; msg.className = 'hevo-discount__msg is-ok'; }
          _paintCart();
        } else {
          /* Roll the code back out and re-sync to the prior state. */
          var i = _manualCodes.indexOf(code);
          if (i !== -1) _manualCodes.splice(i, 1);
          _persistManualCodes();
          _lastAppliedCodesKey = null;
          var revertCodes = _computeCodes(cartData ? cartData.items : []);
          return _applyDiscounts(revertCodes).then(function(fc) {
            if (fc && fc.items) cartData = fc;
            _paintCart();
            if (msg) { msg.textContent = T.discountInvalid; msg.className = 'hevo-discount__msg is-error'; }
          });
        }
      }).catch(function(err) {
        console.error('applyManualDiscount failed:', err);
        var i = _manualCodes.indexOf(code);
        if (i !== -1) _manualCodes.splice(i, 1);
        _persistManualCodes();
        if (msg) { msg.textContent = T.discountInvalid; msg.className = 'hevo-discount__msg is-error'; }
      }).finally(function() {
        btn.disabled = false;
        btn.textContent = originalLabel;
      });

      return false;
    },

    /* Remove a manually-applied code and refresh prices immediately. */
    removeManualDiscount: function(code) {
      var i = _manualCodes.indexOf(code);
      if (i === -1) return;
      _manualCodes.splice(i, 1);
      _persistManualCodes();
      var msg = document.getElementById('hevoDiscountMsg');
      if (msg) { msg.textContent = ''; msg.className = 'hevo-discount__msg'; }
      _lastAppliedCodesKey = null;
      var codes = _computeCodes(cartData ? cartData.items : []);
      _applyDiscounts(codes).then(function(fc) {
        if (fc && fc.items) cartData = fc;
        _paintCart();
      });
    }
  };

  /* ──────────────── INTERCEPT ADD-TO-CART (FETCH MONKEY-PATCH) ──────────────── */
  var _originalFetch = window.fetch;
  window.fetch = function(url, options) {
    var urlStr = (typeof url === 'string') ? url : (url && url.url ? url.url : '');
    var isAddToCart = urlStr.indexOf('/cart/add') !== -1;

    var result = _originalFetch.apply(this, arguments);

    if (isAddToCart && !window._hevoInternalAdd) {
      result.then(function(response) {
        return response.clone().json();
      }).then(function() {
        setTimeout(function() {
          HevoCart.open();
        }, 100);
      }).catch(function() {});
    }

    return result;
  };

  // Hide the Impact theme's built-in cart drawer
  var _impactHideStyle = document.createElement('style');
  _impactHideStyle.textContent = [
    'cart-drawer { display: none !important; }',
    '.shopify-section-cart-drawer { display: none !important; }',
    '#shopify-section-cart-drawer { display: none !important; }',
    '.cart-drawer:not(.hevo-cart-drawer) { display: none !important; }',
    '.cart-drawer__overlay:not(.hevo-cart-overlay) { display: none !important; }',
    'mini-cart:not(.hevo-cart-drawer) { display: none !important; }',
    '.mini-cart:not(.hevo-cart-drawer) { display: none !important; }'
  ].join(' ');
  document.head.appendChild(_impactHideStyle);

  // Intercept form submits as a fallback
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    var formData = new FormData(form);
    var btn = form.querySelector('[type="submit"]');
    var originalHTML = btn ? btn.innerHTML : '';

    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<span class="hevo-spinner"></span>';
    }

    window._hevoInternalAdd = true;
    _originalFetch('/cart/add.js', {
      method: 'POST',
      body: formData
    }).then(function() {
      window._hevoInternalAdd = false;
      HevoCart.open();
    }).catch(function(err) {
      window._hevoInternalAdd = false;
      console.error('Add to cart failed:', err);
    }).finally(function() {
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = originalHTML;
      }
    });
  }, true);

  // Refresh cart if theme fires its own event
  document.addEventListener('cart:refresh', function() {
    if (document.getElementById('hevoCartDrawer').classList.contains('is-open')) {
      renderCart();
    }
  });

  /* ──────────────── HOOK INTO CART ICON ──────────────── */
  document.addEventListener('click', function(e) {
    var cartLink = e.target.closest('a[href="/cart"], a[href$="/cart"], [data-action="open-cart"]');
    if (cartLink) {
      e.preventDefault();
      e.stopPropagation();
      /* Toggle, not open. The cart icon renders as a × while the drawer is
         open and is the only close control, so a handler that always opened
         made that × a no-op — it closed and this immediately reopened. */
      var drawer = document.getElementById('hevoCartDrawer');
      if (drawer && drawer.classList.contains('is-open')) HevoCart.close();
      else HevoCart.open();
    }
  }, true);

  // ESC key to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') HevoCart.close();
  });

  /* ──────────────── APPLY TRANSLATIONS ──────────────── */
  function applyTranslations() {
    var set = function(id, text) { var el = document.getElementById(id); if (el) el.textContent = text; };

    set('hevoCartTitleText', T.cart);
    set('hevoEmptyText', T.emptyCart);
    set('hevoEmptyCta', T.emptyCta);
    set('hevoUpsellTitle', T.upsellTitle);
    set('hevoRecsTitle', T.recsTitle);
    set('hevoDiscountToggleLabel', T.discountToggle);
    set('hevoDiscountBtn', T.discountApply);
    set('hevoTotalLabel', T.total);
    set('hevoCheckoutBtn', T.checkout);
    /* No-op when accelerated checkout is off, or on /cart where the page's
       own buttons render instead of the drawer's. */
    set('hevoAcceleratedOr', T.acceleratedOr);
    set('hevoTrustText', T.trustText);

    /* Discount input placeholder is an attribute, not text content. */
    var discInput = document.getElementById('hevoDiscountInput');
    if (discInput) discInput.setAttribute('placeholder', T.discountPlaceholder);
  }

  applyTranslations();
  renderManualChips();
  renderCart();

  (function () {
    var scroll = document.getElementById('hevoRecsScroll');
    if (!scroll) return;
    var raf = 0;
    scroll.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; window.HevoCart.updateRecsNav(); });
    }, { passive: true });
    /* Cards are re-rendered with the cart; re-check the arrows when they change. */
    new MutationObserver(function () { window.HevoCart.updateRecsNav(); }).observe(scroll, { childList: true });
    window.HevoCart.updateRecsNav();
  })();

})();
